import styled from 'styled-components';

import AddIcon from '../../images/health-content/add-icon.svg';
import warningIcon from '../../images/health-content/warning-icon.svg';

export const Card = styled.button`
  border: 1px solid #e3e3e3;
  border-radius: 12px;
  text-align: left;
  width: 100%;
`;

export const ErrorText = () => {
  return (
    <div className="flex mt-8px">
      <img src={warningIcon} alt="" />
      <p className="text-body-s ml-4px text-accent2-shades4">
        Please enter a valid value
      </p>
    </div>
  );
};

export const LogButton = ({ buttonText, onClick }) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className="flex justify-center items-center w-100 bg-txtlight-shades4 rounded-lg text-caption-l font-semibold py-2.5 mt-10 clickable"
    >
      <img src={AddIcon} alt=""></img>
      <span className="ml-8px">{buttonText}</span>
    </button>
  );
};
